import { createElement } from 'react';
import styled from 'styled-components';
import { createProps } from '@nicollet/common';

/**
 * @deprecated
 * Use either the helper class .l-container-fixed or .l-container in a containing element instead.
 * <div className="l-container-fixed> is the same as <Grid>
 * <div className="l-container> is the same as <Grid fluid>
 */

const Grid = props => {
  var _a, _b;

  return createElement((_a = props.tagName) !== null && _a !== void 0 ? _a : 'div', createProps(props, (_b = props.className) !== null && _b !== void 0 ? _b : ''));
};
/**
 * @deprecated
 * Use either the helper class .l-container-fixed or .l-container in a containing element instead.
 * <div className="l-container-fixed> is the same as <Grid>
 * <div className="l-container> is the same as <Grid fluid>
 */


Grid.displayName = 'Grid (deprecated)';
const StyledGrid = styled(Grid)`
  margin-left: auto;
  margin-right: auto;
  max-width: ${props => props.fluid ? 'none' : '1400px'};
  width: 100%;
`;
StyledGrid.displayName = 'Grid (deprecated)';

export { StyledGrid as Grid };
